import useIntlStore from "@/stores/useIntlStore";
import en_US from "../../../submodules/oam-common-const/requestCode/en-US";
import zh_CN from "../../../submodules/oam-common-const/requestCode/zh-CN";
import { getT } from "@/utils/intlUtils";

const t = getT();

const enUS = {
  ...en_US,
  E00000: "System Error",
  E00016: "Not Latest Version",
  E00005: "Authentication Failed",
};

const zhCN = {
  ...zh_CN,
  E00000: "未知错误",
  E00016: "版本不一致",
  E00005: "鉴权失败",
};

const getErrorMessage = (code: string, defaultMessmage: string) => {
  const { locale } = useIntlStore.getState();

  const messages = locale === "zh-CN" ? zhCN : enUS;

  const message = messages[code];

  return message || defaultMessmage || t("未知错误");
};

export default getErrorMessage;
